import { ONBOARDING_STEPS, OnboardingStep } from 'entities/game';

export const INTERACTIVE_ELEMENT_GOALKEEPER_ANIMATIONS = {
	idle: 'idle',
	leftStep: 'leftStep',
	lose: 'lose',
	rightStep: 'rightStep',
	win: 'win',
} as const satisfies Record<string, string>;

export const INTERACTIVE_ELEMENT_GATES_ANIMATIONS = {
	default: 'default',
	goal: 'goal',
} as const satisfies Record<string, string>;

export const INTERACTIVE_ELEMENT_MOVE_SIDES = {
	left: 'left',
	right: 'right',
} as const satisfies Record<string, string>;

export const INTERACTIVE_ELEMENT_MESSAGES = {
	skillIncredible: 'skill-incredible',
	goodGame: 'good-game',
	luckNextTime: 'luck-next-time',
} as const satisfies Record<string, string>;

export const INTERACTIVE_ELEMENT_CENTER_COLUMN = 2;

export type InteractiveElementGoalkeeperAnimation =
	(typeof INTERACTIVE_ELEMENT_GOALKEEPER_ANIMATIONS)[keyof typeof INTERACTIVE_ELEMENT_GOALKEEPER_ANIMATIONS];

export type InteractiveElementGatesAnimation =
	(typeof INTERACTIVE_ELEMENT_GATES_ANIMATIONS)[keyof typeof INTERACTIVE_ELEMENT_GATES_ANIMATIONS];

export type InteractiveElementMoveSide =
	(typeof INTERACTIVE_ELEMENT_MOVE_SIDES)[keyof typeof INTERACTIVE_ELEMENT_MOVE_SIDES];

export type InteractiveElementMessage =
	(typeof INTERACTIVE_ELEMENT_MESSAGES)[keyof typeof INTERACTIVE_ELEMENT_MESSAGES];

export type InteractiveElementBall = {
	x: number;
	y: number;
	size: number;
	visible: boolean;
};

export const ONBOARDING_POPOVER_TEXTS = {
	[ONBOARDING_STEPS.GAME_FIELD]: ['choose-cell', 'empty-cell'],
	[ONBOARDING_STEPS.BET_MENU]: ['bet-menu'],
	[ONBOARDING_STEPS.WAGER_FIELD]: ['calculator-bet'],
	[ONBOARDING_STEPS.BET_CALCULATOR]: ['calculator-pad'],
	[ONBOARDING_STEPS.BET_BUTTON]: ['win-big'],
} as const satisfies Record<OnboardingStep, string[]>;
